import Tag from "src/components/atoms/Tag";
import { usePluginConfig } from "../../contexts/pluginContext";
import Category from "../../models/Category";
import Link from "../atoms/Link";

// Deprecated: This component is using an older design and the name is misleading as we have a new definition
// of what we call an event tag. It has been replaced by CategoryLinks, but is still used in some places.
const EventTags = ({ event, count }) => {
	const pluginConfig = usePluginConfig();
	const frameConfig = pluginConfig.frameConfig;
	const publisherSettings = pluginConfig.publisherSettings;
	const rootCategories = pluginConfig.rootCategories;

	const buildPath = (categoryData) => {
		const rootCategory = rootCategories.find((rootCategory) => {
			return rootCategory.id === categoryData.id;
		});

		if (rootCategory) {
			return {
				pathname: `/${new Category(rootCategory).slug}`,
			};
		}

		return {
			pathname: "/",
			query: {
				subcategory: `${categoryData.id}|${categoryData.name}`,
			},
		};
	};

	const linkForCalendar = (categoryData) => (
		<Link href={buildPath(categoryData)} key={categoryData.id}>
			<span className="inline-block mr-1">
				<Tag text={categoryData.name} />
			</span>
		</Link>
	);

	const linkForWidget = (categoryData) => {
		const { pathname, query } = buildPath(categoryData);
		const host = publisherSettings.publisher.url;
		const queryObject = new URLSearchParams(query);
		const queryString = query ? `&${queryObject.toString()}` : "";
		const href = `${host}?_evDiscoveryPath=${pathname}${queryString}`;

		return (
			<a href={href} target="_blank" key={categoryData.id} rel="noopener">
				<span className="inline-block mr-1">
					<Tag text={categoryData.name} />
				</span>
			</a>
		);
	};

	return (
		<>
			{event.categoryNamesWithIds
				.slice(0, count || 2)
				.map((categoryData) =>
					frameConfig.type === "widget"
						? linkForWidget(categoryData)
						: linkForCalendar(categoryData),
				)}
		</>
	);
};

export default EventTags;
